// extracted by mini-css-extract-plugin
export default {"bodyPopup":"Modal_bodyPopup__XeR3P","form":"Modal_form__FEIVf","fields":"Modal_fields__66gaQ","desc":"Modal_desc__4lRBu"};